<template>
	<div class="text-center" ref="createTareaRef" id="text-test">
		<v-dialog
			v-model="modalStatus"
			max-width="800"
			scrollable
			persistent
		>
			<v-card>
				<v-card-text class="pa-0">
					<div class="py-4 px-8">
						<div class="d-flex flex-row align-center justify-space-between">
							<div class="d-flex flex-row align-center">
								<v-icon color="white" small class="info-icon mr-2">mdi-file-document-multiple-outline</v-icon>
								<p class="mb-0 font-weight-bold text-primary title"
									:class="$vuetify.breakpoint.mobile ? 'body-2':''">Crear Posible Adicional</p>
							</div>
							<div class="d-flex flex-row align-center">
								<v-btn class="mx-2" fab dark x-small color="#fb8c00" @click="minimizeForm">
									<v-icon dark>mdi-window-minimize</v-icon>
								</v-btn>
								<v-btn class="mx-2" fab dark small color="#F4516C" @click="closeModalSelf()">
									<v-icon dark>mdi-close</v-icon>
								</v-btn>
							</div>
						</div>
						<v-row align="center" class="mt-2">
							<v-col cols="12">
								<p class="mb-0 body-2"><b class="text-primary">El posible adicional será emitido a tu nombre:</b> {{$store.userStore.state.userInfo.name}}</p>
								<p class="mb-0 body-2"><b class="text-primary">En el proyecto:</b> {{$store.projectsStore.state.selectedProject.name}}</p>
								<p class="mb-0 caption">Ten en cuenta que el posible adicional en esencia es considerado una "Tarea"</p>
							</v-col>
						</v-row>
						<v-form ref="form" v-model="validform">
							<v-row align="center">
								<v-col cols="12">
									<v-text-field
										v-model="newTaskForm.title"
										label="Título"
										placeholder="Ingrese título del posible adicional"
										outlined
										required
										hide-details
										:rules="requiredRule"
										@keyup="sendToSearch"
									>
										<template slot="append">
											<v-progress-circular
												v-if="searching"
												:size="20"
												:width="2"
												color="#2D4B95"
												indeterminate
											></v-progress-circular>
											<v-chip
												v-else-if="searchResultsCount > 0"
												dark
												small
												color="#5E85EF"
												@click="showResults = true">
												<v-avatar
													left
													class="primary darken-4"
												>
													{{searchResultsCount}}
												</v-avatar>
												<p class="mb-0">Elementos similares</p>
												<v-icon>mdi-chevron-down</v-icon>
											</v-chip>
										</template>
									</v-text-field>
									<SearchBlockForms v-if="showResults" :searching="searching" :searchResult="searchResult" :closeResults="closeResults"/>
								</v-col>
							</v-row>
							<v-row align="center" class="mt-0">
								<v-col cols="12">
									<h2 class="ml-2 mr-4 mb-0 body-1 font-weight-bold">Descripción</h2>
									<InteractionEditor
										v-model="newTaskForm.description"
										item_type="task"
										@paste-image="onPasteImage"
										@mentions-updated="onMentionsUpdated"
									/>
									<div class="my-2 d-flex flex-row" style="width: 100%">
										<div class="d-flex justify-space-between" style="width: 100%" :class="$vuetify.breakpoint.mobile ? 'flex-column':'flex-row'">
											<div class="d-flex flex-row align-center flex-wrap" style="flex: 1;">
												<div v-for="(file,index) in filesPreview" :key="index" class="ma-1" style="flex: 1 0 45%;">
													<div v-if="file.src" class="preview-img-container">
														<v-btn
															icon
															color="#5E85EF"
															x-small
															class="button-preview-img"
															@click="removeAttachment(file, index)"
														>
															<v-icon>mdi-close</v-icon>
														</v-btn>
														<img :src="file.src" class="preview-img"/>
													</div>
													<div v-else class="d-flex flex-row align-center justify-start">
														<v-btn
															icon
															color="#5E85EF"
															x-small
															@click="removeAttachment(file, index)"
														>
															<v-icon>mdi-close</v-icon>
														</v-btn>
														{{file.name}}
													</div>
												</div>
											</div>
											<v-btn
												class="mx-2 my-1"
												rounded
												color="white"
												raised
												@click="onButtonClick"
											>
												<p class="mb-0 text-primary">Adjuntar Archivo</p>
											</v-btn>
											<input
												ref="uploader"
												class="d-none"
												type="file"
												@change="onFileChanged"
											>
										</div>
									</div>
								</v-col>
							</v-row>
							<v-row align="center">
								<v-col cols="12">
									<v-row align="start">
										<v-col cols="12" sm="3">
											<h2 class="ml-2 mr-4 mb-0 body-1 font-weight-bold">Asociaciones</h2>
										</v-col>
										<v-col cols="12" sm="9">
											<ItemsAssociationInputSelect ref="itemsAssociationInputSelectRef" :changeItems="changeAssociations"/>
										</v-col>
									</v-row>
								</v-col>
							</v-row>
							<v-row align="center">
								<v-col cols="12">
									<v-row align="center">
										<v-col cols="12" sm="3">
											<h2 class="ml-2 mr-4 mb-0 body-1 font-weight-bold">Prioridad</h2>
										</v-col>
										<v-col cols="12" sm="9">
											<div class="d-flex" :class="$vuetify.breakpoint.mobile ? 'flex-column':'flex-row'">
												<v-btn
													class="mx-2 my-1"
													color="#F4516C"
													dark
													small
													:outlined="newTaskForm.priority === 3"
													@click="() => newTaskForm.priority = 3"
												>
													<p class="mb-0">! Inmediata</p>
												</v-btn>
												<v-btn
													class="mx-2 my-1"
													color="warning"
													dark
													small
													:outlined="newTaskForm.priority === 2"
													@click="() => newTaskForm.priority = 2"
												>
													<p class="mb-0">! Media</p>
												</v-btn>
												<v-btn
													class="mx-2 my-1"
													color="#3EBFA3"
													dark
													small
													:outlined="newTaskForm.priority === 1"
													@click="() => newTaskForm.priority = 1"
												>
													<p class="mb-0">! Estándar</p>
												</v-btn>
											</div>
										</v-col>
									</v-row>
								</v-col>
							</v-row>
							<!-- <v-row align="center">
								<v-col cols="12">
									<v-row align="center">
										<v-col cols="12" sm="3">
											<h2 class="ml-2 mr-4 mb-0 body-1 font-weight-bold">Fecha Crítica</h2>
										</v-col>
										<v-col cols="12" sm="9">
											<v-menu
												v-model="datePicker"
												:close-on-content-click="false"
												max-width="290"
											>
												<template v-slot:activator="{ on, attrs }">
													<v-text-field
														:value="newTaskForm.critical_date"
														label="Fecha Crítica"
														prepend-inner-icon="mdi-calendar"
														readonly
														v-bind="attrs"
														v-on="on"
														outlined
														dense
														class="remove-bottom-details date-limit-input"
														@click:clear="date = null"
													></v-text-field>
												</template>
												<v-date-picker
													locale="es"
													v-model="newTaskForm.critical_date"
													@change="datePicker = false"
												></v-date-picker>
											</v-menu>
										</v-col>
									</v-row>
								</v-col>
							</v-row> -->
							<div class="d-flex align-center justify-end mt-2 mb-3">
								<v-btn
									color="grey"
									text
									@click="() => showUserActions = !showUserActions"
								>
									<p class="mb-0 caption text-none">Responsable y Participantes</p>
									<v-icon>{{showUserActions ? 'mdi-chevron-up':'mdi-chevron-down'}}</v-icon>
								</v-btn>
							</div>
							<v-row align="start" v-show="showUserActions" v-if="checkPermissions(['assign_responsable_task'])">
								<v-col cols="12">
									<v-row align="center">
										<v-col cols="12" sm="3">
											<h2 class="ml-2 mr-4 mb-0 body-1 font-weight-bold">Asignar</h2>
										</v-col>
										<v-col cols="12" sm="9" class="py-0">
											<v-autocomplete
												v-model="newTaskForm.responsable"
												:loading="$store.usersStore.state.loadingUserList"
												:items="getFinalUserList()"
												:search-input.sync="searchUsers"
												item-text="name"
												item-value="id"
												item-disabled="false"
												:filter="usersFilter"
												single-line
												outlined
												dense
												label="Seleccione Usuario Responsable"
												:hint="checkPermissions(['assign_responsable_task']) ? 'Ingresa al menos 5 caracteres para iniciar búsqueda de usuarios (por nombre o email)':'Puedes asignarte la tarea a ti o a un usuario Jefe OT'"
												persistent-hint
											>
												<template v-slot:item="data">
													<v-list-item-avatar>
														<img v-if="data.item.info && data.item.info.avatar" :src="data.item.info.avatar">
														<v-icon v-else>mdi-account</v-icon>
													</v-list-item-avatar>
													<v-list-item-content>
														<v-list-item-title>{{data.item.name}} <span class="light-blue-text">{{data.item.projectjob.userjobtype.name}}</span></v-list-item-title>
														<v-list-item-subtitle v-html="data.item.email"></v-list-item-subtitle>
													</v-list-item-content>
												</template>
											</v-autocomplete>
										</v-col>
									</v-row>
								</v-col>
							</v-row>
							<v-row align="start" v-show="showUserActions">
								<v-col cols="12">
									<v-row align="center">
										<v-col cols="12" sm="3">
											<h2 class="ml-2 mr-4 mb-0 body-1 font-weight-bold">Participantes</h2>
										</v-col>
										<v-col cols="12" sm="9" class="py-0">
											<v-autocomplete
												v-model="selectedParticipantToAdd"
												:loading="$store.usersStore.state.loadingUserList"
												:items="availableParticipants"
												:search-input.sync="searchUsersParticipants"
												item-text="name"
												:filter="usersFilter"
												single-line
												outlined
												dense
												hide-selected
												hide-details
												label="Seleccione Usuarios Participantes"
												placeholder="Buscar usuario..."
												prepend-inner-icon="mdi-magnify"
												return-object
												clearable
												@change="onParticipantSelected"
											>
												<template v-slot:selection="{}"></template>
												<template v-slot:item="data">
													<v-list-item-avatar size="32">
														<img v-if="data.item.info && data.item.info.avatar" :src="data.item.info.avatar">
														<div v-else class="participant-avatar-fallback">{{ initials(data.item.name) }}</div>
													</v-list-item-avatar>
													<v-list-item-content>
														<v-list-item-title>{{ data.item.name }} <span class="light-blue-text">{{ data.item.projectjob.userjobtype.name }}</span></v-list-item-title>
														<v-list-item-subtitle>{{ data.item.email }}</v-list-item-subtitle>
													</v-list-item-content>
												</template>
											</v-autocomplete>

											<div v-if="participantObjects.length" class="participant-list mt-2">
												<p class="participant-list-label">Seleccionados ({{ participantObjects.length }})</p>
												<div v-for="p in participantObjects" :key="p.id" class="participant-card">
													<div class="participant-card-left">
														<div class="participant-avatar">
															<img v-if="p.info && p.info.avatar" :src="p.info.avatar" />
															<span v-else>{{ initials(p.name) }}</span>
														</div>
														<div class="participant-card-info">
															<span class="participant-card-name">{{ p.name }}</span>
															<span class="participant-card-role" v-if="p.projectjob && p.projectjob.userjobtype">{{ p.projectjob.userjobtype.name }}</span>
														</div>
													</div>
													<div class="participant-card-right">
														<v-menu
															v-model="participantDateMenus[p.id]"
															:close-on-content-click="false"
															max-width="290"
															min-width="290"
															offset-y
															nudge-bottom="4"
														>
															<template v-slot:activator="{ on, attrs }">
																<button class="participant-date-btn" type="button" v-bind="attrs" v-on="on">
																	<v-icon size="14" color="#6B7280">mdi-calendar-outline</v-icon>
																	<span>{{ participantDates[p.id] || 'Sin fecha límite' }}</span>
																	<v-icon v-if="participantDates[p.id]" size="12" color="#9CA3AF" @click.stop="clearParticipantDate(p.id)">mdi-close</v-icon>
																</button>
															</template>
															<v-date-picker
																locale="es"
																:value="participantDates[p.id]"
																no-title
																@input="setParticipantDate(p.id, $event)"
															/>
														</v-menu>
														<button class="participant-remove-btn" type="button" @click="removeParticipantByID(p.id)">
															<v-icon size="16" color="#9CA3AF">mdi-close</v-icon>
														</button>
													</div>
												</div>
											</div>

										</v-col>
									</v-row>
								</v-col>
							</v-row>
							<!-- <v-row>
								<v-col cols="12">
									<v-row>
										<v-col cols="12" sm="3">
											<h2 class="ml-2 mr-4 mb-0 body-1 font-weight-bold">Enviar Copia</h2>
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-btn
														class="ml-2 mr-4 px-0"
														color="grey"
														text
														v-bind="attrs"
														v-on="on"
														:disabled="disabledAttachSelector"
														@click="() => attachFiles = !attachFiles"
													>
														<v-icon small class="mr-1">{{attachFiles ? 'mdi-check-circle-outline':'mdi-checkbox-blank-circle-outline'}}</v-icon>
														<p class="mb-0 text-capitalize caption">Enviar adjuntos</p>
													</v-btn>
												</template>
												<span>Se adjuntarán los archivos en el correo de notificación</span>
											</v-tooltip>
										</v-col>
										<v-col cols="12" sm="9">
											<v-combobox
												v-model="copy_to"
												:loading="$store.usersStore.state.loadingUserList"
												:items="getFinalUserList()"
												:search-input.sync="searchUsersCopyTo"
												item-text="name"
												item-value="id"
												single-line
												outlined
												dense
												required
												multiple
												label="Enviar copia por correo"
												hint="Se enviará una copia en PDF de la RDI a los usuarios que indiques aquí. Puedes ingresar un correo que no esté en el listado, escríbelo y presiona enter."
												persistent-hint
												return-object
												taggable
											>
												<template v-slot:item="data">
													<v-list-item-avatar>
														<img v-if="data.item.info && data.item.info.avatar" :src="data.item.info.avatar">
														<v-icon v-else>mdi-account</v-icon>
													</v-list-item-avatar>
													<v-list-item-content>
														<v-list-item-title>{{data.item.name}} <span class="light-blue-text">{{data.item.projectjob.userjobtype.name}}</span></v-list-item-title>
														<v-list-item-subtitle v-html="data.item.email"></v-list-item-subtitle>
													</v-list-item-content>
												</template>
											</v-combobox>
										</v-col>
									</v-row>
								</v-col>
							</v-row>
							<v-row>
								<v-col cols="12">
									<v-row>
										<v-col cols="12" sm="3">
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<h2 class="ml-2 mr-4 mb-0 body-1 font-weight-bold"
														v-bind="attrs"
														v-on="on">Recordatorio</h2>
												</template>
												<span>Se agregará esta tarea a tus recordatorios semanales</span>
											</v-tooltip>
										</v-col>
										<v-col cols="12" sm="9">
											<div>
												<v-btn
													v-for="(day, index) in weekDays"
													:key="index"
													dark
													x-small
													color="#5E85EF"
													:outlined="!isWeekDaySelected(index)"
													class="mx-1"
													@click="addWeekDay(index)"
												>
													<p class="mb-0">{{day}}</p>
												</v-btn>
											</div>
										</v-col>
									</v-row>
								</v-col>
							</v-row>
							<v-row align="center">
								<v-col cols="12">
									<h2 class="ml-2 mr-4 mb-0 body-1 font-weight-bold">Listado de Tareas del Posible Adicional</h2>
									<v-text-field
										v-model="newTarea"
										label="Tarea"
										placeholder="Escribe la descripción de la tarea y presiona enter o el botón"
										class="ma-2 pt-0 remove-bottom-details"
										@keydown.enter="addNewTarea()"
									>
										<template v-slot:append>
											<v-btn
												icon
												:disabled="!newTarea || newTarea === ''"
												color="#5E85EF"
												@click="addNewTarea()"
											>
												<v-icon>mdi-plus-circle</v-icon>
											</v-btn>
										</template>
									</v-text-field>
									<v-list-item-group>
											<v-list-item v-for="(subtarea, i) in subtareas" :key="i">
												<template v-slot:default>
													<v-list-item-action>
														<v-btn
															icon
															color="#F4516C"
															@click="removeNewTarea(i)"
														>
															<v-icon>mdi-close</v-icon>
														</v-btn>
													</v-list-item-action>
													<v-list-item-content>
														<v-list-item-title>{{ subtarea.title }}</v-list-item-title>
														<v-list-item-subtitle>Agregado: {{ subtarea.date_added }}</v-list-item-subtitle>
													</v-list-item-content>
												</template>
											</v-list-item>
										</v-list-item-group>
								</v-col>
							</v-row> -->
							<v-row align="center">
								<v-col cols="12">
									<div class="d-flex flex-row justify-end">
										<div class="d-flex flex-row">
											<!-- <v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-btn
														class="mx-2 my-1"
														color="#2D4B95"
														text
														v-bind="attrs"
														v-on="on"
														@click="() => newTaskForm.private = !newTaskForm.private"
													>
														<v-icon small class="mr-1">{{newTaskForm.private ? 'mdi-check-circle-outline':'mdi-checkbox-blank-circle-outline'}}</v-icon>
														<p class="mb-0 text-primary text-capitalize caption">Tarea Privada</p>
													</v-btn>
												</template>
												<span>Sólo podrá ser visualizada por ti y por la persona que asignes como responsable</span>
											</v-tooltip> -->
											<v-btn
												class="mx-2 my-1"
												rounded
												color="white"
												raised
												@click="closeModalSelf()"
											>
												<p class="mb-0 text-primary">Cancelar</p>
											</v-btn>
											<v-btn
												v-if="checkPermissions(['create_additionals'])"
												class="mx-2 my-1"
												rounded
												color="#2D4B95"
												raised
												:loading="loadingData"
												@click="() => preCreateTarea()"
											>
												<p class="mb-0 white--text">{{confirmButtonText}}</p>
											</v-btn>
											<v-btn
												v-else
												class="mx-2 my-1"
												rounded
												color="#2D4B95"
												raised
												:loading="loadingData"
												@click="saveDraftAndClose()"
											>
												<p class="mb-0 white--text">Guardar Borrador</p>
											</v-btn>
										</div>
									</div>
								</v-col>
							</v-row>
						</v-form>
					</div>
				</v-card-text>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import moment from 'moment'
import _debounce from 'lodash/debounce'
import { v4 as uuidv4 } from 'uuid'
import {create} from '@/helpers/api/tasks'
import {searchUsersByEmail} from '@/helpers/api/project'
import {search} from '@/helpers/api/general'
import {deleteFile} from '@/helpers/api/fileManager'
import {create as createDraftAPI, update as updateDraftAPI} from '@/helpers/api/drafts'
import EventBus from '@/helpers/event_bus'
import SearchBlockForms from '@/components/Globals/Headers/SearchBlockForms'
import ItemsAssociationInputSelect from '@/components/Globals/Helpers/ItemsAssociationInputSelect'
import InteractionEditor from '@/components/Globals/Helpers/InteractionEditor'

export default {
	name: 'CreateAdicionalLikelyModal',
	components: { InteractionEditor, SearchBlockForms, ItemsAssociationInputSelect },
	props: {
		modalStatus:{
			type: Boolean,
			default: false
		},
		closeModal: {
			type: Function,
			required: true
		},
		draftToLoad: {
			type: Object,
			default: null
		}
	},
	watch: {
		searchUsers (val) {
			if(val && val.length > 5){
				// this.searchUsersBD(val)
				this.searchUsersLocal(val)
			}
		},
		searchUsersParticipants (val) {
			if(val && val.length > 5){
				// this.searchUsersBD(val)
				this.searchUsersLocal(val)
			}
		},
		searchUsersCopyTo (val) {
			if(val && val.length > 5){
				// this.searchUsersBD(val)
				this.searchUsersLocal(val)
			}
		},
		draftToLoad(newVal) {
			if(newVal) {
				this.loadDraft(newVal)
			}
		},
		filesPreview() {
			this.checkFilesAttach()
		},
		newTaskForm: {
			handler() {
				this.handleFormChange()
			},
			deep: true
		},
		subtareas: {
			handler() {
				this.handleFormChange()
			},
			deep: true
		},
		participants: {
			handler(newVal) {
				this.handleFormChange()
				newVal.forEach(id => {
					if (!(id in this.participantDates)) {
						this.$set(this.participantDates, id, null)
					}
					if (!(id in this.participantDateMenus)) {
						this.$set(this.participantDateMenus, id, false)
					}
				})
				Object.keys(this.participantDates).forEach(id => {
					if (!newVal.includes(Number(id)) && !newVal.includes(id)) {
						this.$delete(this.participantDates, id)
						this.$delete(this.participantDateMenus, id)
					}
				})
			},
			deep: true
		},
		copy_to: {
			handler() {
				this.handleFormChange()
			},
			deep: true
		},
		associations: {
			handler() {
				this.handleFormChange()
			},
			deep: true
		}
	},
	data: () => ({
		validform: true,
		showUserActions: false,
		newTaskForm: {
			title: '',
			priority: 1,
			description: '',
			subtareas: [],
			participants: [],
			responsable: null,
			critical_date: null,
			private: false,
			copy_to: null,
			reminder: [],
			associations: [],
			reminder_repeatable: true,
			is_posible_additional: true
		},
		disabledAttachSelector: true,
		attachFiles: false,
		datePicker: false,
		copy_to: [],
		requiredRule: [
			v => !!v || 'Campo requerido'
		],
		newTarea: '',
		associations: [],
		subtareas: [],
		participants: [],
		filesPreview: [],
		content: '',
		loadingData: false,
		loadingUsers: false,
		usersToSelect: [],
		searchUsers: null,
		searchUsersParticipants: null,
		searchUsersCopyTo: null,
		showResults: false,
		searchResultsCount: 0,
		searching: false,
		searchResult: [],
		cancelTimer: 7,
		inCancelTime: false,
		cancelInterval: null,
		confirmButtonText: 'Confirmar',
		weekDays: ['Lunes','Martes','Miércoles','Jueves','Viernes','Sábado','Domingo'],
		draftId: null,
		draftCreated: false,
		draftUpdateInterval: 20,
		draftSaveTimer: null,
		handleFormChangeDebounced: null,
		isResetting: false,
		participantDates: {},
		participantDateMenus: {},
		selectedParticipantToAdd: null,
		newInteractionMentions: []
	}),
	beforeUnmount(){
		if(this.draftSaveTimer){
			clearInterval(this.draftSaveTimer)
			this.draftSaveTimer = null
		}
	},
	mounted(){
		this.handleFormChangeDebounced = _debounce(() => this.checkAndCreateDraft(), 1000)
		if(this.$store.consultasStore.state.borradorTarea){
			this.newTaskForm = {...this.newTaskForm, ...this.$store.consultasStore.state.borradorTarea}
			if (this.$store.consultasStore.state.borradorTarea.associations && this.$store.consultasStore.state.borradorTarea.associations.length > 0) {
				this.associations = this.$store.consultasStore.state.borradorTarea.associations
				this.$refs.itemsAssociationInputSelectRef.setSelectedItems(this.associations)
			}
			this.$store.consultasStore.commit('setBorradorTarea', null)
		}
		if(this.$store.usersStore.state.usersList.length === 0){
			this.getUsersList()
		}
		// else if(!this.checkPermissions(['assign_responsable_task'])){
		// 	this.newTaskForm.responsable = this.$store.userStore.state.userInfo.id
		// }
		setTimeout(() => {
			this.pasteListener()
		}, 1000);
		// Cargar draft si viene en la prop al montar el componente
		if(this.draftToLoad){
			this.loadDraft(this.draftToLoad)
		}
		this.fileListeners()
	},
	computed: {
		availableParticipants() {
			return this.$store.usersStore.state.usersList.filter(u => !this.participants.includes(u.id) && u.id !== this.newTaskForm.responsable)
		},
		participantObjects() {
			return this.$store.usersStore.state.usersList.filter(u => this.participants.includes(u.id))
		}
	},
	methods: {
		async onPasteImage(file){
			await this.createDraft()
			this.onFileChanged(null, file)
		},
		onMentionsUpdated(userIds){
			this.newInteractionMentions = userIds
		},
		handleFormChange(){
			if(!this.isResetting && this.handleFormChangeDebounced){
				this.handleFormChangeDebounced()
			}
		},
		checkAndCreateDraft(){
			if(!this.draftCreated && !this.draftId){
				this.createDraft()
			}
		},
		async createDraft(){
			if(this.draftCreated) return
			this.draftCreated = true
			
			const draftData = {
				project_id: this.$store.projectsStore.state.selectedProject.id,
				type: 4,
				data: JSON.stringify({
					is_posible_additional: true,
					form: this.newTaskForm,
					subtareas: this.subtareas,
					participants: this.participants,
					copy_to: this.copy_to,
					associations: this.associations
				})
			}
			
			try {
				const response = await createDraftAPI(draftData)
				if(response.code === 200){
					this.draftId = response.draft.id
					this.startDraftUpdateTimer()
				}
        else if(response.offline) {
					this.$store.globalStore.dispatch('addMessage', {
						message: 'No hay conexión. El borrador se mantendrá localmente y podrás retomarlo cuando vuelvas a tener conexión desde la sección de borradores.',
						title: 'Borrador guardado localmente',
						created: new Date(),
						type: 'warning',
						icon: 'mdi-wifi-off',
						color: '#F59E0B'
					})
					this.draftId = response.draft.id
					this.startDraftUpdateTimer()
					return this.draftId
        }
			} catch (error) {
				console.error('Error al crear borrador:', error)
				this.draftCreated = false
			}
		},
		startDraftUpdateTimer(){
			if(this.draftSaveTimer){
				clearInterval(this.draftSaveTimer)
				this.draftSaveTimer = null
			}
			
			this.draftSaveTimer = setInterval(() => {
				this.updateDraft()
			}, this.draftUpdateInterval * 1000)
		},
		async updateDraft(){
			if(!this.draftId) return
			
			const draftData = {
				id: this.draftId,
				type: 4,
				data: JSON.stringify({
					is_posible_additional: true,
					form: this.newTaskForm,
					subtareas: this.subtareas,
					participants: this.participants,
					copy_to: this.copy_to,
					associations: this.associations
				})
			}
			
			try {
				await updateDraftAPI(draftData)
			} catch (error) {
				console.error('Error al actualizar borrador:', error)
			}
		},
		changeAssociations(associations){
			this.associations = associations.map((association) => {
				return { type: association.type, id: association.id }
			})
		},
		closeResults(){
			this.showResults = false
			this.searching = false
		},
		sendToSearch: _debounce(function(){ this.searchForString(this.newTaskForm.title) }, 800),
		async searchForString(searchString){
			this.searching = true
			const data = {
				search: searchString,
				project_id: this.$store.projectsStore.state.selectedProject.id,
				exclude_description: true
			}
			const searchResult = await search(data)
			if(searchResult.code == 200){
				this.searchResult = searchResult
				this.searchResultsCount = searchResult.tasks.length + searchResult.rdis.length
			}
			this.searching = false
		},
		addWeekDay(index){
			const found = this.newTaskForm.reminder.findIndex((itemReminder) => itemReminder === index)
			if(found !== -1){
				this.newTaskForm.reminder.splice(found, 1)
			}
			else{
				this.newTaskForm.reminder.push(index)
			}
			if(this.newTaskForm.reminder.length === 0){
				this.newTaskForm.reminder_repeatable = false
			}
		},
		isWeekDaySelected(index){
			return this.newTaskForm.reminder.includes(index)
		},
		minimizeForm(){
			this.updateDraft()
			let title = 'Borrador P.Adicional: '
			if(this.newTaskForm.title && this.newTaskForm.title != ''){
				title += this.newTaskForm.title
			}
			else{
				title += 'Sin Título'
			}
			const data = {
				task_id: uuidv4(),
				title,
				type: 'Posible Adicional',
				type_id: 3,
				number: null,
				newTaskForm: this.newTaskForm,
				is_posible_additional: true,
				draft_id: this.draftId || null
			}
			this.$store.globalStore.commit('addTaskToTasksHandler', data)
			this.closeModalSelf()
		},
		closeModalSelf(){
			if(this.handleFormChangeDebounced){
				this.handleFormChangeDebounced.cancel()
			}
			this.updateDraft()
			this.isResetting = true
			if(this.draftSaveTimer){
				clearInterval(this.draftSaveTimer)
				this.draftSaveTimer = null
			}

			this.closeModal()

			this.newTaskForm = {
				title: '',
				priority: 1,
				description: '',
				subtareas: [],
				participants: [],
				responsable: null,
				critical_date: null,
				files: [],
				private: false,
				copy_to: null,
				reminder: [],
				reminder_repeatable: true
			}
			this.associations = []
			this.copy_to = []
			this.filesPreview = []
			this.subtareas = []
			this.participants = []
			this.newTarea = ''
			this.searchUsers = null
			this.searchUsersParticipants = null
			this.searchUsersCopyTo = null
			this.showResults = false
			this.searchResultsCount = 0
			this.searching = false
			this.searchResult = []
			this.usersToSelect = []
			this.datePicker = false
			this.loadingData = false
			this.loadingUsers = false
			this.draftId = null
			this.draftCreated = false
			this.participantDates = {}
			this.participantDateMenus = {}
			this.selectedParticipantToAdd = null
			this.newInteractionMentions = []

			this.$nextTick(() => {
				setTimeout(() => {
					this.isResetting = false
				}, 100)
			})
		},
		async loadDraft(draft){
			if(!draft) return

			// Reset estado previo
			this.isResetting = true
			if(this.draftSaveTimer){
				clearInterval(this.draftSaveTimer)
				this.draftSaveTimer = null
			}

			// Parsear data si es string
			let draftData = draft.data
			if(typeof draftData === 'string'){
				try {
					draftData = JSON.parse(draftData)
				} catch (error) {
					console.error('Error al parsear draft data:', error)
					this.isResetting = false
					return
				}
			}

			// Populate formulario
			if(draftData.form){
				this.newTaskForm = {...this.newTaskForm, ...draftData.form}
			}
			this.newInteractionMentions = []

			// Populate subtareas
			if(draftData.subtareas && Array.isArray(draftData.subtareas)){
				this.subtareas = [...draftData.subtareas]
			}

			// Populate participantes
			if(draftData.participants && Array.isArray(draftData.participants)){
				this.participants = [...draftData.participants]
			}

			// Populate copy_to
			if(draftData.copy_to && Array.isArray(draftData.copy_to)){
				this.copy_to = [...draftData.copy_to]
			}

			// Populate asociaciones
			if(draftData.associations && Array.isArray(draftData.associations)){
				this.associations = [...draftData.associations]
			}

			// Cargar archivos del draft
			try{
				const filePreviews = []
				
				if(draft.files && Array.isArray(draft.files)){
					for(const file of draft.files){
						if(file.mime_type && file.mime_type.includes('image')){
							if(file.pathmedia?.path){
								filePreviews.push({src: file.pathmedia.path, id: file.id, name: file.name})
							}
							else{
								filePreviews.push({noImage: true, id: file.id, name: file.name})
							}
						}
						else{
							filePreviews.push({noImage: true, id: file.id, name: file.name})
						}
					}
				}
				
				this.filesPreview = filePreviews
			}
			catch(error){
				console.error('Error al cargar archivos del draft:', error)
			}

			// Establecer draftId
			this.draftId = draft.id
			this.draftCreated = true

			// Iniciar timer de actualizaciones
			this.startDraftUpdateTimer()

			// Limpiar estado
			this.$nextTick(() => {
				this.isResetting = false
			})

			// Notificar al usuario
			const data = {
				message: 'Borrador cargado correctamente. Los cambios se guardarán automáticamente.',
				title: 'Borrador Cargado',
				created: new Date(),
				type: 'success',
				icon: 'mdi-check-circle',
				color: '#3EBFA3'
			}
			this.$store.globalStore.dispatch('addMessage', data)
		},
		getFinalUserList(participants = false){
			if(this.checkPermissions(['assign_responsable_task'])){
				return participants ? this.$store.usersStore.state.usersList.filter((user) => user.id !== this.$store.userStore.state.userInfo.id && user.id !== this.newTaskForm.responsable):this.$store.usersStore.state.usersList
			}
			else{
				return this.$store.usersStore.state.usersList.filter((user) => {
					if(participants){
						return user.id !== this.newTaskForm.responsable
					}
					return user && ( ( user.projectjob && user.projectjob.job_type_id == 2 ) || user.id == this.$store.userStore.state.userInfo.id )
				})
			}
		},
		pasteListener(){
			const textEditor = document.querySelector('#create-tarea-text-editor .ProseMirror')
			if(textEditor){
				textEditor.addEventListener('paste', async (event) => {
					const dT = event.clipboardData || window.clipboardData
					const file = dT.files[0]
					if(file){
						const uuid = uuidv4()
						if(file.type.includes('image')){
							const base64File = await this.toBase64(file)
							this.filesPreview.push({src: base64File, name: file.name, uuid})
						}
						else{
							this.filesPreview.push({noImage: true, name: file.name, uuid})
						}
					}
				})
			}
		},
		async getUsersList(){
			const data = {
				project_id: this.$store.projectsStore.state.selectedProject.id,
				start: 0,
				limit: 20
			}
			this.$store.usersStore.dispatch('getUsersList', data)
		},
		async getAdditionalLikelyList(){
			let project_id = null
			if(this.$store.projectsStore.state.selectedProject){
				project_id = this.$store.projectsStore.state.selectedProject.id
			}
			else{
				const id = localStorage.getItem('selectedProjectID')
				project_id = parseInt(id)
			}
			if(project_id){
				this.$store.adicionalesStore.dispatch('getAdditionalsLikely', {project_id})
			}
		},
		getColorStatus(){
			if(this.$store.consultasStore.state.currentTarea.status === 1){
				return '#3EBFA3'
			}
			return '#F4516C'
		},
		async searchUsersBD(email){
			this.loadingUsers = true
			const data = {
				email,
				project_id: this.$store.projectsStore.state.selectedProject.id
			}
			const users = await searchUsersByEmail(data)
			if(users.code === 200){
				this.usersToSelect = users.users
			}
			this.loadingUsers = false
		},
		searchUsersLocal(searchString){
			this.loadingUsers = true
			const search = this.$store.usersStore.state.usersList
			this.usersToSelect = search.filter((user) =>{
				return user.name.includes(searchString) || user.email.includes(searchString) 
			})
			this.loadingUsers = false
		},
		usersFilter(item, queryText) {
			const name = item.name.toLowerCase()
			const email = item.email.toLowerCase()
			const searchText = queryText.toLowerCase()

			return name.indexOf(searchText) > -1 || email.indexOf(searchText) > -1
		},
		addNewTarea(){
			this.subtareas.push({title: this.newTarea, date_added: moment().format('DD/MM/YYYY HH:mm')})
			this.newTarea = ''
		},
		onButtonClick() {
			this.$refs.uploader.click()
		},
		async onFileChanged(e, file = null) {
			if(!this.draftId && !this.draftCreated){
				await this.createDraft()
			}
			const newFile = e?.target?.files?.[0] || file
			if(!newFile) return
			const uuid = uuidv4()
			
			if(newFile.type.includes('image')){
				const base64File = await this.toBase64(newFile)
				this.filesPreview.push({src: base64File, name: newFile.name, uuid})
			}
			else{
				this.filesPreview.push({noImage: true, name: newFile.name, uuid})
			}
			
			// Enviar a subida con draft_id y type: 13
			const fileToUpload = {
				type: 13,
				payload: {draft_id: this.draftId, project_id: this.$store.projectsStore.state.selectedProject.id, uuid},
				description: this.newTaskForm.title,
				total: newFile.size,
				uuid,
				file: newFile,
				attach_files: this.attachFiles,
				copy_to: this.newTaskForm.copy_to
			}
			this.$store.globalStore.commit('setFilesToUploadCenter', fileToUpload)
		},
		removeAttachment(file, index){
			this.filesPreview.splice(index, 1)
			if(file.id){
				deleteFile({file_id: file.id})
			}
		},
		checkFilesAttach(){
			if(this.filesPreview.length > 0){
				this.disabledAttachSelector = false
			}
			else{
				this.disabledAttachSelector = true
				this.attachFiles = false
			}
		},
    fileListeners(){
      EventBus.$on('completedFileUpload', async (payload) => {
        if(payload && payload.draft_id === this.draftId){
					const findIndex = this.filesPreview.findIndex((file) => file.uuid === payload.uuid)
					if(findIndex !== -1){
						this.$set(this.filesPreview[findIndex], 'id', payload.file.id)
					}
        }
      })
    },
		toBase64(file) {
			return new Promise((resolve) => {
				var reader = new FileReader();
				reader.readAsDataURL(file);
				reader.onload = function () {
					resolve(reader.result)
				};
				reader.onerror = function () {
					resolve(null)
				};
			})
		},
		preCreateTarea(){
			if(this.inCancelTime){
				clearInterval(this.cancelInterval)
				this.confirmButtonText = 'Confirmar'
				this.inCancelTime = false
				return null
			}
			if(this.newTaskForm.description === '' || !this.newTaskForm.description){
				const datas = {
					message: 'Por favor escribe una descripción. Este campo no puede estar vacio.',
					title: 'Error',
					created: new Date(),
					type: 'success',
					icon: 'mdi-alert-circle',
					color: '#fb8c00'
				}
				this.$store.globalStore.dispatch('addMessage', datas)
				return false
			}
			if(this.$refs.form.validate()){
				this.inCancelTime = true
				this.cancelTimer = 7
				this.confirmButtonText = 'Cancelar (' + this.cancelTimer + ')'
				this.cancelInterval = setInterval(() => {
					this.cancelTimer--
					this.confirmButtonText = 'Cancelar (' + this.cancelTimer + ')'
					if(this.cancelTimer == 0){
						this.inCancelTime = false
						clearInterval(this.cancelInterval)
						this.createTarea()
					}
				}, 1000);
			}
		},
		async saveDraftAndClose() {
			try {
				this.loadingData = true
				await this.updateDraft()
				this.$store.globalStore.dispatch('addMessage', {
					message: 'Borrador guardado correctamente.',
					title: 'Borrador Guardado',
					type: 'success',
					icon: 'mdi-check-circle',
					color: '#3EBFA3',
					created: new Date()
				})
				this.closeModalSelf()
			} catch(error) {
				console.error('Error al guardar borrador:', error)
				this.$store.globalStore.dispatch('addMessage', {
					message: 'Error al guardar el borrador. Por favor, intenta de nuevo.',
					title: 'Error',
					type: 'error',
					icon: 'mdi-alert-circle',
					color: '#fb8c00',
					created: new Date()
				})
			} finally {
				this.loadingData = false
			}
		},
		async createTarea(){
			this.loadingData = true
			this.confirmButtonText = 'Confirmar'
			if(this.copy_to.length > 0){
				const emails_copy = this.copy_to.map((email) => {
					let emailData = null
					if(email.email){
						emailData = {email: email.email, name: email.name}
					}
					else{
						emailData = {email, name: ''}
					}
					return emailData
				})
				this.newTaskForm.copy_to = JSON.stringify(emails_copy)
			}
			const hasReminders = this.newTaskForm.reminder.length > 0
			this.newTaskForm.subtareas = JSON.stringify(this.subtareas)
			this.newTaskForm.participants = JSON.stringify(this.participants.map(id => ({ id, limit_date: this.participantDates[id] || null })))
			this.newTaskForm.reminder = JSON.stringify(this.newTaskForm.reminder)
			this.newTaskForm.project_id = this.$store.projectsStore.state.selectedProject.id
			this.newTaskForm.draft_id = this.draftId

			const associations = [...this.associations]

			this.newTaskForm.associations = JSON.stringify(associations)
			
			const formData = new FormData()
			Object.keys(this.newTaskForm).forEach((key) => {
				if(this.newTaskForm[key]){
					formData.append(key, this.newTaskForm[key])
				}
			})
			this.newInteractionMentions.forEach((mention) => formData.append('mentions[]', mention))
			const task = await create(formData)
			if(task.code === 200){
				// Detener timer del draft después de confirmación exitosa
				if(this.draftSaveTimer){
					clearInterval(this.draftSaveTimer)
					this.draftSaveTimer = null
				}
				//Verificar si se debe cargar una tarea previamente cargada (asociación)
				if(associations.length > 0){
					associations.forEach(association => {
						EventBus.$emit('reload_element', association)
					});
				}
				
				// Envío correo con adjuntos, función verifica que no se esté subiendo algún archivo aún
				const checkSendEmailData = {
					type: 1,
					item_id: task.task.id,
					copy_to: this.newTaskForm.copy_to,
					attach_files: this.attachFiles
				}
				this.$store.globalStore.dispatch('checkSendingEmail', checkSendEmailData)

				this.getAdditionalLikelyList()
				this.closeModalSelf()

				// Se cambia la llamada directo por el evento, así sólo será escuchado si el componente está montado (evita llamar a la api innecesariamente)
				// this.$store.projectsStore.dispatch('getDashboardInfo');
				EventBus.$emit('onProjectElementsChange')

				this.setMessage(task.task, false)
				hasReminders && this.$store.notificationsStore.dispatch('getReminders')
			}
			this.loadingData = false
		},
		setMessage(task, filesToUC = false){
			let message = 'Haz click aquí para visualizarla.'
			if(filesToUC){
				message += ' Hay algunos archivos que se están cargando.'
			}
			const data = {
				message,
				title: 'Se ha creado la tarea como posible adicional ' + task.number,
				created: new Date(),
				type: 'success',
				icon: 'mdi-check-circle',
				color: '#3EBFA3',
				action: 'task',
				task_id: task.id
			}
			this.$store.globalStore.dispatch('addMessage', data)
		},
		initials(name) {
			if (!name) return '?'
			const parts = name.trim().split(' ')
			return parts.length >= 2
				? (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
				: parts[0].slice(0, 2).toUpperCase()
		},
		onParticipantSelected(user) {
			if (user && !this.participants.includes(user.id)) {
				this.participants.push(user.id)
			}
			this.$nextTick(() => { this.selectedParticipantToAdd = null })
			this.searchUsersParticipants = null
		},
		setParticipantDate(id, date) {
			this.$set(this.participantDates, id, date)
			this.$set(this.participantDateMenus, id, false)
		},
		clearParticipantDate(id) {
			this.$set(this.participantDates, id, null)
		},
		removeParticipantByID(id) {
			const idx = this.participants.indexOf(id)
			if (idx !== -1) this.participants.splice(idx, 1)
		}
	}
};
</script>

<style scoped>
	.info-container{
		color: #606060;
	}
	.text-primary{
		color: #2D4B95;
	}
	.info-icon{
		background-color: #2D4B95;
		border-radius: 25px;
		padding: 3px;
		width: 35px;
		height: 35px;
	}
	.info-icon.small-icon{
		width: 25px;
		height: 25px;
	}
	.info-img{
		width: 100%;
		max-height: 50px;
		object-fit: contain;
	}
	.adjuntos-container{
		background-color: #EFEFEF;
		max-height: 95px;
		overflow-y: scroll;
	}
	.interaction-container{
		width: 100%;
		background-color: #E5E9F2;
		border-radius: 5px;
		position: relative;
		padding: 12px;
	}
	.user-avatar.small{
		width: 25px;
		height: 25px;
	}
	.light-blue-text{color: #5E85EF;}
	.interaction-container .icon-arrow{
		font-size: 80px;
		position: absolute;
		top: 20px;
		line-height: inherit;
	}
	.interaction-container.right .icon-arrow{
		left: -46px;
	}
	.interaction-container.left .icon-arrow{
		right: -46px;
	}
	.date-limit-input{
		max-width: 250px;
	}
	.preview-img-container{
		position: relative;
	}
	.preview-img{
		width: 50px;
		height: 50px;
		border-radius: 10px;
		object-fit: contain;
	}
	.button-preview-img{
		position: absolute;
		top: -1px;
		left: -1px;
		background-color: white;
	}
	/deep/ .remove-bottom-details .v-text-field__details{display: none;}
	/deep/ .remove-bottom-details .v-input__slot{margin-bottom: 0;}
/*  /deep/ .text-editor.tiptap-vuetify-editor .ProseMirror{
		margin: 0!important;
	}*/

	/* --- Participant cards --- */
	.participant-list {
		display: flex;
		flex-direction: column;
		gap: 6px;
	}
	.participant-list-label {
		font-size: 11px;
		color: #9CA3AF;
		margin-bottom: 4px;
		margin-left: 2px;
	}
	.participant-card {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 10px 14px;
		border-radius: 10px;
		background: #F8FAFC;
		border: 1px solid #E2E8F0;
		gap: 8px;
	}
	.participant-card-left {
		display: flex;
		align-items: center;
		gap: 10px;
		min-width: 0;
		flex: 1;
	}
	.participant-avatar {
		width: 36px;
		height: 36px;
		border-radius: 50%;
		background: #2D4B95;
		color: white;
		font-size: 12px;
		font-weight: 700;
		display: flex;
		align-items: center;
		justify-content: center;
		overflow: hidden;
		flex-shrink: 0;
	}
	.participant-avatar img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
	.participant-avatar-fallback {
		width: 32px;
		height: 32px;
		border-radius: 50%;
		background: #2D4B95;
		color: white;
		font-size: 11px;
		font-weight: 700;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.participant-card-info {
		display: flex;
		flex-direction: column;
		min-width: 0;
	}
	.participant-card-name {
		font-size: 13px;
		font-weight: 600;
		color: #1F2937;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	.participant-card-role {
		font-size: 11px;
		color: #6B7280;
	}
	.participant-card-right {
		display: flex;
		align-items: center;
		gap: 6px;
		flex-shrink: 0;
	}
	.participant-date-btn {
		display: flex;
		align-items: center;
		gap: 4px;
		padding: 4px 8px;
		border-radius: 6px;
		border: 1px solid #D1D5DB;
		background: white;
		cursor: pointer;
		font-size: 11px;
		color: #374151;
		white-space: nowrap;
		transition: border-color 0.15s;
	}
	.participant-date-btn:hover {
		border-color: #2D4B95;
	}
	.participant-remove-btn {
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 4px;
		border-radius: 6px;
		border: none;
		background: transparent;
		cursor: pointer;
		transition: background 0.15s;
	}
	.participant-remove-btn:hover {
		background: #FEE2E2;
	}
</style>